import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _Form from "@hzero-front-ui/hzero-ui/lib/Form";
import React from "react";
import { ConfigStepContainer, StyledConfigRow } from "./index.style";
import ListConfig from "../ComponentsConfig/ListConfig";
import PromptConfig from "../ComponentsConfig/PromptConfig";
import CarouselConfig from "../ComponentsConfig/CarouselConfig";
import BadgeConfig from "../ComponentsConfig/BadgeConfig";
var ConfigStepThree = function ConfigStepThree(_ref) {
  var form = _ref.form,
    config = _ref.config;
  var getFieldDecorator = form.getFieldDecorator;
  return /*#__PURE__*/React.createElement(ConfigStepContainer, null, /*#__PURE__*/React.createElement(StyledConfigRow, null, getFieldDecorator("list", {
    initialValue: config.list
  })( /*#__PURE__*/React.createElement(ListConfig, null))), /*#__PURE__*/React.createElement(StyledConfigRow, null, getFieldDecorator("prompt", {
    initialValue: {
      alert: config.alert,
      notification: config.notification,
      tooltip: config.tooltip
    }
  })( /*#__PURE__*/React.createElement(PromptConfig, null))), /*#__PURE__*/React.createElement(StyledConfigRow, null, getFieldDecorator("carousel", {
    initialValue: config.carousel
  })( /*#__PURE__*/React.createElement(CarouselConfig, null))), /*#__PURE__*/React.createElement(StyledConfigRow, null, getFieldDecorator("badge", {
    initialValue: config.badge
  })( /*#__PURE__*/React.createElement(BadgeConfig, null))));
};
export default _Form.create({
  onValuesChange: function onValuesChange(props, field, values) {
    if (props.onChange) {
      var list = values.list,
        prompt = values.prompt,
        carousel = values.carousel,
        badge = values.badge;
      props.onChange(_objectSpread({
        carousel: carousel,
        badge: badge,
        list: list
      }, prompt));
    }
  }
})(ConfigStepThree);